import React from 'react';
import secureStorage from '../../config/encrypt';
import { ADMIN_ROLES } from '../../config/constant';
import Unauthorized from '../login/Unauthorized';

/**
 * SuperAdminGuard
 * Wraps any component and renders <Unauthorized /> if the logged-in
 * admin is not a Super Admin (admin_role_id !== 1).
 *
 * Usage in routes:
 *   { path: "/some-path", component: () => <SuperAdminGuard><SomeComponent /></SuperAdminGuard> }
 *
 * Or as a HOC:
 *   export default withSuperAdminAccess(MyComponent);
 */
const SuperAdminGuard = ({ children }) => {
    const loginUserInfo = secureStorage.getItem('loginUserInfo');
    const isSuperAdmin  = loginUserInfo?.user_data?.admin_role_id === ADMIN_ROLES.super_admin;

    return isSuperAdmin ? children : <Unauthorized />;
};

export default SuperAdminGuard;
